import React from "react";
import { connect } from "react-redux";
import { logout } from "ducks/app";
import { Menu, Dropdown, Avatar, Badge } from "antd";

const mapDispatchToProps = dispatch => ({
  logout: event => {
    event.preventDefault();
    dispatch(logout());
  }
});

const mapStateToProps = (state, props) => ({
  userState: state.app.userState
});

@connect(
  mapStateToProps,
  mapDispatchToProps
)
class LocationMenu extends React.Component {
  render() {
    const menu = (
      <Menu selectable={false}>
        <Menu.Item>
          <div className="rfq__widget__system-status__item">Location 1</div>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item>
          <div className="rfq__widget__system-status__item">Location 2</div>
        </Menu.Item>
      </Menu>
    );
    return (
      <div className="topbar__dropdown d-inline-block  mr-4">
        <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
          <a className="ant-dropdown-link" href="/">
            <Avatar className="topbar__avatar" icon="pushpin" />
            <span className="ml-2">Location 1</span>
          </a>
        </Dropdown>
      </div>
    );
  }
}

export default LocationMenu;



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/TopBar/LocationMenu/index.js